import { StateComplianceDisclaimerScreen } from '@/components/StateComplianceDisclaimerScreen';

export default function StateComplianceDisclaimer() {
  return <StateComplianceDisclaimerScreen />;
}
